export default {
  ready: 'ready',
  startProject: 'startProject',
  doesntStartProject: 'doesntStartProject',
  claimResources: 'claimResources',
  acceptBlueOverCapacity: 'acceptBlueOverCapacity',
  declineBlueOverCapacity: 'declineBlueOverCapacity',
  updateGantt: 'updateGantt',
}
